import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { convertToDateOnlyString, getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import {
    //model
    wirelessIntlRoamingAccessModel
    //action
    , setSubscriptionDetails
    , setFormSubmitted
    , setResetLoading
    , getInternationalRequest,
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-intl-roaming-access.settings';

export const intlRoamingAccessModelInitialState = wirelessIntlRoamingAccessModel;

const defaultState = () => ({
    subscription: {}
    , startDate: ''
    , endDate: ''
    , formSubmitted: false  
    , internationalRequestOptions : []
});

const initialState = defaultState();

export const wirelessIntlRoamingAccessActions = {
    onROBSubscripitionAutoSelect: (value, empId) => async (dispatch, state) => {
        const { wirelessIntlRoamingAccessForm } = state().form;
        const { subscriptionList, isWirelineRequest, isRequestOnBehalf, requestOnBehalfData, requestTypeId } = state().createRequest;
        const { requestData } = state().requestDetail;
        let url = 'external/autosuggest/getAllDeviceSubscriptionSuggestions/';
        var res = await httpGet(url
            + empId + '/'
            + requestTypeId
            + '?val=' + encodeURIComponent(value));
        if (value === '') {
            dispatch(actions.reset('wirelessIntlRoamingAccessForm'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            var obj = res.find(o => o['CircuitCode'] === value);
            if (obj != null && obj.CircuitId != wirelessIntlRoamingAccessForm.circuitId) {
                dispatch(actions.reset('wirelessIntlRoamingAccessForm'));
                dispatch(actions.change('wirelessIntlRoamingAccessForm.circuitCode', value));
                dispatch(actions.change('wirelessIntlRoamingAccessForm.circuitId', obj.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });

            }
        }
    },
    getNewIntlRoamingAccessFormData: (orderId) => async (dispatch, state) => {
        const { Order, Circuit, BusinessJustification } = state().requestDetail.requestData;
        const { subscription } = state().wirelessIntlRoamingAccessRequest;
        const { requestTypeId, subscriptionList } = state().createRequest;
        if (orderId) {
            dispatch(actions.reset('wirelessIntlRoamingAccessForm'));           
            dispatch({ type: setSubscriptionDetails, data: subscriptionList.length != 0 ? subscriptionList[0] : subscription });
            dispatch(actions.change('wirelessIntlRoamingAccessForm.circuitCode', Circuit.CircuitCode));
            dispatch(actions.change('wirelessIntlRoamingAccessForm.circuitId', Circuit.CircuitId));
            if (orderId) { 
                dispatch(actions.change('wirelessIntlRoamingAccessForm.businessJustification', BusinessJustification.BusinessJustification));
                dispatch(actions.change('wirelessIntlRoamingAccessForm.countriesToBeVisited', Order.CountriesToBeVisited));
                dispatch(actions.change('wirelessIntlRoamingAccessForm.additionalInformation', BusinessJustification.AdditionalInformation));
                dispatch(actions.change('wirelessIntlRoamingAccessForm.startDate', new Date(Order.StartDate)));
                dispatch(actions.change('wirelessIntlRoamingAccessForm.endDate', new Date(Order.EndDate)));
                dispatch(actions.change('wirelessIntlRoamingAccessForm.RequestTypeId', Order.RequestType.RequestTypeID));
            }
        }
    },

    onSubscriptionSelect: (value, propsName, objects, index) => async (dispatch, state) => {
        const { wirelessIntlRoamingAccessForm } = state().form;
        const { takeActionCircuitId } = state().createRequest;

        if (value === '' || !propsName) {
            dispatch(actions.reset('wirelessIntlRoamingAccessForm'));
            dispatch(actions.change('wirelessIntlRoamingAccessForm.RequestTypeId', value));
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            if(propsName) {
                var obj=null              
                if(objects !== null && objects !== undefined) {
                    if(index !== -1 && index !== undefined && index !== null) {
                        obj=objects[index]
                    }
                    else if(objects.length === 1) {
                        obj=objects.find(o => o[propsName] === value);
                    }
                    else if (objects.length > 1) {
                        obj = objects.find(o => o[propsName] === value & o['CircuitId'] === takeActionCircuitId);
                    }
                }
                if (obj != null && obj.CircuitId != wirelessIntlRoamingAccessForm.circuitId) {                   
                    dispatch(actions.reset('wirelessIntlRoamingAccessForm'));
                    dispatch(actions.change('wirelessIntlRoamingAccessForm.RequestTypeId', value));
                    dispatch(actions.change('wirelessIntlRoamingAccessForm.circuitCode', value));
                    dispatch(actions.change('wirelessIntlRoamingAccessForm.circuitId', obj.CircuitId));
                    dispatch({ type: setSubscriptionDetails, data: obj });
                }
            }
        }
    }
    , resetWirelessIntlRoamingAccessForm: (isResetRequestOnBehalf = false) => (dispatch, state) => {

        const { takeActionCircuitCode } = state().createRequest;
        if((takeActionCircuitCode !== '' && takeActionCircuitCode !== undefined && takeActionCircuitCode !== null) && isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: false });
            return;
        }
        if (isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelessIntlRoamingAccessForm'));
            dispatch(actions.change('wirelessIntlRoamingAccessForm.circuitCode', ''));
            dispatch(actions.change('wirelessIntlRoamingAccessForm.circuitId', ''));
            dispatch(actions.change('wirelessIntlRoamingAccessForm.RequestTypeId', ''));
            dispatch({ type: setSubscriptionDetails, data: {} });

            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5);
        }
        else if (!isResetRequestOnBehalf) {
            dispatch(actions.reset('wirelessIntlRoamingAccessForm'));
            dispatch(actions.change('wirelessIntlRoamingAccessForm.RequestTypeId', ''));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }

        dispatch(actions.reset('wirelessIntlRoamingAccessForm'));
        dispatch(actions.change('wirelessIntlRoamingAccessForm.RequestTypeId', ''));
        dispatch({ type: setSubscriptionDetails, data: {} });
        dispatch({ type: setFormSubmitted, data: false });     
    },
    fetchIntlOptions: () => async (dispatch, state) => {
        var res = await httpGet('external/intlRoamingAccessRequest/internationalRequestOptions');
        dispatch({ type: getInternationalRequest, data: res });
    }

    , submitRequest: () => async (dispatch, state) => {

        const { wirelessIntlRoamingAccessForm } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData, isUpdateRequest, subscriptionList } = state().createRequest;
        const { subscription } = state().wirelessIntlRoamingAccessRequest;
        const { Order, Circuit, CircuitOrderId, OrderInfoId } = state().requestDetail.requestData;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
        }
        if (isUpdateRequest) {
            var data = {
                ChangeRequestModel: {
                    ...userData
                    , CircuitId: wirelessIntlRoamingAccessForm.circuitId,
                    VendorDetailId: subscriptionList.length != 0 ? subscriptionList[0].VendorDetailId : subscription.VendorDetailId,
                    AdditionalInformation: wirelessIntlRoamingAccessForm.additionalInformation,
                    StartDate: convertToDateOnlyString(wirelessIntlRoamingAccessForm.startDate),
                    EndDate: convertToDateOnlyString(wirelessIntlRoamingAccessForm.endDate),
                    BusinessJustification: wirelessIntlRoamingAccessForm.businessJustification,
                    CountriesToBeVisited: wirelessIntlRoamingAccessForm.countriesToBeVisited,
                    RequestTypeId: wirelessIntlRoamingAccessForm.RequestTypeId
                    ,OrderId: Order.OrderId
                    , CircuitOrderId: CircuitOrderId
                    , OrderInfoId: OrderInfoId,
                }
                , ...wirelessIntlRoamingAccessForm
                , IsAmending: true
            };
        }
        else {
            var data = { 
                ChangeRequestModel: {
                    ...userData
                    , CircuitId: wirelessIntlRoamingAccessForm.circuitId,
                    VendorDetailId: subscription.VendorDetailId,
                    AdditionalInformation: wirelessIntlRoamingAccessForm.additionalInformation,
                    StartDate: convertToDateOnlyString(wirelessIntlRoamingAccessForm.startDate),
                    EndDate: convertToDateOnlyString(wirelessIntlRoamingAccessForm.endDate),
                    BusinessJustification: wirelessIntlRoamingAccessForm.businessJustification,
                    CountriesToBeVisited: wirelessIntlRoamingAccessForm.countriesToBeVisited,
                    RequestTypeId: wirelessIntlRoamingAccessForm.RequestTypeId,
                },
            };
        }
        dispatch({ type: setFormSubmitted, data: true });

        var res = await httpPost('external/intlRoamingAccessRequest/submitIntlRoamingAccess', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInternationalRequest:
            return {
                ...state,
                internationalRequestOptions: action.data
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            };     
        default: return state;
    }
}